import View from './View';

import logo from 'url:../../../src/img/logo.png';

class SignupView extends View {
  _parentElement = document.querySelector('.main');
  _errorMessage = 'Signup Error Message';
  _message = 'Signup Success Message';

  addHandlerSignup(handler) {
    const signupForm = document.querySelector('.user-cred__form');

    if (!signupForm) return;
    const signupBtn = document.querySelector('.btn--signup');
    signupForm.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      signupBtn.disabled = true;
      signupBtn.textContent = 'Signing up...'; // Update text for feedback

      const dataArr = [...new FormData(this)];
      const data = Object.fromEntries(dataArr);
      handler(data);
    });
  }

  _generateMarkup() {
    return `
          <div class="row user-cred">
        <div class="user-cred__head">
          <h1 class="user-cred__heading">Create Account</h1>          
        </div>
        <div class="user-cred__container">
          <div class="user-cred__logo">
            <div class="user-cred__logo--img">
              <img src="${logo}" alt="Pragya Enterprises Logo" />
             
            </div>
            <h3 class="user-cred__title"></h3>
            <p class="paragraph user-cred__description">
              For every student, every classroom.<br />
              Real uniforms.
            </p>
          </div>
          <div class="user-cred__form--container">
            <form
              action="#"
              class="user-cred__form"
              name="userCredForm"
              autocomplete="off"
            >
              <!-- NAME -->
              <div class="user-cred__name label-input">
                <label for="name">Your Name</label>
                <input
                  type="string"
                  id="name"
                  placeholder="channi"
                  name="name"
                  autofocus
                  required
                />
              </div>
              <!-- EMAIL -->
              <div class="user-cred__email label-input">
                <label for="email">Email</label>
                <input
                  type="email"
                  id="email"
                  placeholder="channi@pragya.enterprises"
                  name="email"
                  
                  required
                />
              </div>

              <!-- PASSWORD -->
              <div class="user-cred__email label-input">
                <label for="password">Password</label>
                <input
                  type="password"
                  placeholder="enter new password"
                  name="password"
                  id="password"
                  required
                />
              </div>

              <!-- PASSWORD CONFIRM -->
              <div class="user-cred__email label-input">
                <label for="password-confirm">Confirm Password </label>
                <input
                  type="password"
                  placeholder="enter new confirm password"
                  name="passwordConfirm"
                  id="password-confirm"
                  required
                />
              </div>
              <div class="user-cred__terms">
                <input
                  type="checkbox"
                  id="terms"
                  class="user-cred__terms--check"
                  required
                />
                <label class="user-cred__terms--label" for="terms"
                  >I agree with <a href="/terms" style="text-decoration: none; color: #0066fb" target="_blank"> Terms & Conditions.</a></label
                >
              </div>
              <div class="user-cred__btn--container">
                <button type="submit" class="btn btn--signup">Sign Up</button>
              </div>
            </form>
          </div>
        </div>

      </div>
    `;
  }
}

export default new SignupView();
